import { PathBase } from "./path-base";

export class PathBaseWithId extends PathBase {
	static readonly idKey: string;

	public static idPlaceholder() {
		return `:${this.idKey}`;
	}

	withId = (id: string) => {
		const pathWithId = `${this.path}/${id}`;
		return {
			path: pathWithId,
		};
	};

	static withId(id: string) {
		const pathWithId = `${this.pathName}/${id}`;
		return {
			path: pathWithId,
		};
	}

	withIdPlaceholder = () => {
		const pathWithIdPlaceholder = `${this.path}/${(
			this.constructor as typeof PathBaseWithId
		).idPlaceholder()}`;
		return {
			path: pathWithIdPlaceholder,
		};
	};

	static withIdPlaceholder() {
		const pathWithIdPlaceholder = `${this.pathName}/${this.idPlaceholder()}`;
		return {
			path: pathWithIdPlaceholder,
		};
	}
}
